import * as React from 'react'
import styled from 'styled-components'

import * as ds from '@bob/design-system'
import * as hooks from '@bob/hooks'

type Search<ITEM> = {
  engine: hooks.useSearchEngine.SearchEngine<ITEM>
  placeholder: string
}

export function Search<ITEM>({ engine, placeholder }: Search<ITEM>): React.ReactElement | null {
  return (
    <SearchInput
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        engine.query.text(event.target.value)
      }}
      onKeyPress={(event) => {
        if (event.key === 'Enter') {
          event.currentTarget.blur()
        }
      }}
      placeholder={placeholder}
      value={engine.query.value.text}
    />
  )
}

const SearchInput = styled(ds.SearchInput)`
  margin-top: 25px;

  @media screen and (${ds.breakpoint.TABLET}) {
    margin-top: 0;
  }
`
